import { Button as MuiButton, Paper, TextField, styled } from '@mui/material'

export const DatePickerDialogPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'filterClockMinutes',
})<{ filterClockMinutes?: boolean }>(({ theme, filterClockMinutes }) => ({
  '& .MuiTypography-overline': {
    paddingRight: theme.spacing(4),
  },
  ...(filterClockMinutes && {
    '& .PrivateClockNumber-disabled': {
      display: 'none',
      pointerEvents: 'none',
    },
    '& [class*="ClockNumber"][class*="disabled"]': {
      display: 'none',
      pointerEvents: 'none',
    },
  }),
}))

export const PickerPlaceholderTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'showPlaceholderStyle',
})<{ showPlaceholderStyle?: boolean }>(({ theme, showPlaceholderStyle }) => ({
  ...(showPlaceholderStyle && {
    '& .MuiInputBase-input': {
      color: theme.palette.text.disabled,
    },
  }),
}))

export const DatePickerClearButtonStyled = styled(MuiButton, {
  shouldForwardProp: prop => prop !== 'hasError',
})<{ hasError?: boolean }>(({ theme, hasError }) => ({
  ...(hasError && {
    [theme.breakpoints.down('sm')]: {
      marginTop: '-12px',
    },
  }),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(1),
  },
}))

export const createDatePickerDialogProps = (filterClockMinutes: boolean) =>
  ({
    onClose: (_: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
      if (reason === 'backdropClick') return
    },
    PaperProps: {
      component: DatePickerDialogPaper,
      filterClockMinutes,
    },
  }) as Record<string, unknown>
